import { CrowdinButton } from '@anytag/shared-atoms';
import { Header, ListWithPagination } from '@anytag/shared-molecules';
import { getOffset, getValuableVariables } from '@anytag/shared-utils';
import { PERMISSION_DENIED } from '@anytag/shared-constants';
import { useQueryHelper, useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { PostsInsightList, PostsInsightFilter, usePostsInsightFilter } from '@anytag/shared-organisms';
import { useAllEngagementsForInsightCheckQuery, EngagementCampaignPostStatusForInsightCheck } from '@anytag/graphql';

export const PostsInsight = () => {
  const { t, navigate, enqueueSnackbar } = useQueryHelper();
  useUpdateDocumentTitle({
    href: '/report',
    alwaysBackToParent: true,
    title: 'appHeader.Posts Insight',
    appHeader: 'appHeader.Posts Insight'
  });
  const { page, limit, filter } = usePostsInsightFilter();
  const { data, loading } = useAllEngagementsForInsightCheckQuery({
    fetchPolicy: 'cache-and-network',
    variables: getValuableVariables({
      limit,
      offset: getOffset(page, limit),
      status: filter.status || null,
      keyword: filter.keyword
    }),
    onError: (error) => {
      if (error.message.includes(PERMISSION_DENIED)) {
        navigate({ to: '/not-found' });
      } else {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      }
    }
  });

  const totalConfirmed = data?.allEngagementsForInsightCheckCount?.totalConfirmed || 0;
  const totalUnconfirmed = data?.allEngagementsForInsightCheckCount?.totalUnconfirmed || 0;
  const totalRecords =
    filter.status === EngagementCampaignPostStatusForInsightCheck.CONFIRMED
      ? totalConfirmed
      : filter.status === EngagementCampaignPostStatusForInsightCheck.UNCONFIRMED
        ? totalUnconfirmed
        : totalConfirmed + totalUnconfirmed;

  return (
    <div className="form-container p-4">
      <Header>
        <CrowdinButton className="ml-auto" />
      </Header>
      <ListWithPagination pagination={{ totalRecords }}>
        <PostsInsightFilter totalConfirmed={totalConfirmed} totalUnconfirmed={totalUnconfirmed} />
        <PostsInsightList
          loading={loading}
          totalRecords={totalRecords}
          data={data?.allEngagementsForInsightCheck?.engagementCampaigns}
        />
      </ListWithPagination>
    </div>
  );
};
